export enum CURRENCY {
  CHF = 'CHF',
  USD = 'USD',
  EUR = 'EUR',
  CZK = 'CZK',
}
